import { observer } from 'mobx-react';
import TopButtons from './component/TopButtons';
import React, { useEffect } from 'react';
import AdviceTimelineGrapView from './AdviceTimelineGraphView';
import AdviceTimelinePageStore from 'pages/AdviceTimelinePage/store/AdviceTimelinePageStore';
import { Button, Divider, Grid } from '@mui/material';
import TopInfoArea from './component/TopInfoArea';
import AdviceTimelineEmoticonView from './AdviceTimelineEmoticonView';
import emoticonImg from '../../assets/image/smile.png';
import chartImg from '../../assets/image/chart.png';

interface Props {
  pageStore: AdviceTimelinePageStore;
}

function AdviceTimelineGraphPage({ pageStore }: Props) {
  useEffect(() => {
    pageStore.fetchChartData('last30day');
  }, []);

  const handleClickBtn = () => {
    pageStore.setIsGraph(!pageStore.isGraph);
  };

  return (
    <Grid>
      <TopInfoArea pageStore={pageStore} />
      <Divider
        style={{
          border: '0.5px solid #eeeeee',
          width: '100%',
          marginTop: '24px',
        }}
      />
      <TopButtons pageStore={pageStore} />
      <Grid
        container
        style={{
          width: '50px',
          height: '50px',
          borderRadius: '15px',
          border: '1px solid #dddddd',
          padding: '15px',
          float: 'right',
          cursor: 'pointer',
          marginRight: '20px',
        }}
        justifyContent={'center'}
      >
        {pageStore.isGraph ? <img width='100%' height='100%' onClick={handleClickBtn} src={chartImg} alt='chartIcon' /> : <img width='100%' height='100%' onClick={handleClickBtn} src={emoticonImg} alt='smileIcon' />}
      </Grid>

      {pageStore.isGraph ? <AdviceTimelineEmoticonView pageStore={pageStore} /> : <AdviceTimelineGrapView pageStore={pageStore} />}
    </Grid>
  );
}

export default observer(AdviceTimelineGraphPage);
